import { Diagram } from 'gojs';
import { map, merge, Observable, share, startWith } from 'rxjs';
import { getToggleStatus, ToggleStatus } from '../actions/get-toggle-status';
import { fromDiagramEvent } from './from-diagram-event';

export const fromToggleStatus = (diagram: Diagram): Observable<ToggleStatus> => {
  const initialValue = getToggleStatus(diagram);
  const expanded$ = fromDiagramEvent(diagram, 'SubGraphExpanded');
  const collapsed$ = fromDiagramEvent(diagram, 'SubGraphCollapsed');

  return merge(expanded$, collapsed$).pipe(
    startWith(initialValue),
    map(() => getToggleStatus(diagram)),
    share(),
  );
};
